import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function HotNews() {
  const featuredArticles = getFeaturedArticles().slice(0, 3);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
            <i className="ri-fire-line"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门爆料
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article, index) => (
            <div key={article.id} className={index === 0 ? 'md:col-span-2 lg:col-span-1' : ''}>
              <ArticleCard article={article} variant={index === 0 ? 'featured' : 'default'} />
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/star-scandal"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            查看更多热门爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}